/**
 * Downloads the preview HTML from the DMS attachment endpoint using a
 * `previewHtmlFileToken`. This avoids re-generating the preview when a valid
 * cached preview already exists.
 */
export const downloadPreviewHtml = async (
    token: string,
    iaUid: string,
    previewWebappBaseUrl: string | undefined,
): Promise<string | undefined> => {
    if (!previewWebappBaseUrl) return undefined;

    const attachmentUrl = new URL(
        `${previewWebappBaseUrl}/indeedapply/applicationpreview/attachment`,
    );
    attachmentUrl.searchParams.set('iaUid', iaUid);
    attachmentUrl.searchParams.set('fileToken', token);

    try {
        const response = await fetch(attachmentUrl.toString(), {
            credentials: 'include',
            method: 'GET',
        });

        if (response.ok) {
            return await response.text();
        }
        return undefined;
    } catch {
        return undefined;
    }
};
